var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 44,
    viewBox: "0 0 63 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5587 7.1081L33.0001 5.5919C37.0238 1.45969 42.5969 -0.421008 48.074 0.53959C56.3497 1.99251 62.4153 9.53807 62.4153 18.3847V19.1187C62.4153 24.371 60.3494 29.3955 56.698 32.9772L34.9939 54.328C34.0931 55.2139 32.904 55.7075 31.6668 55.7075C30.4297 55.7075 29.2406 55.2139 28.3397 54.328L6.63443 32.9772C2.98785 29.3955 0.918335 24.371 0.918335 19.1187V18.3847C0.918335 9.53807 6.98636 1.99251 15.2596 0.53959C20.6286 -0.421008 26.3099 1.45969 30.2255 5.5919L31.5587 7.1081ZM31.5587 12.8413L27.511 8.44965C24.4722 5.24892 20.1361 3.78841 15.8962 4.53385C9.47146 5.66278 4.6538 11.5251 4.6538 18.3847V19.1187C4.6538 23.2573 6.3894 27.1933 9.25646 30.0156L30.9582 51.3665C31.1503 51.5563 31.4026 51.6576 31.5587 51.6576C31.9311 51.6576 32.1833 51.5563 32.3755 51.3665L54.0796 30.0156C56.9382 27.1933 58.5717 23.2573 58.5717 19.1187V18.3847C58.5717 11.5251 53.8634 5.66278 47.4374 4.53385C43.0894 3.78841 38.8615 5.24892 35.8227 8.44965L31.5587 12.8413Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/iconHeart.b8247b1cd20db1cd06ba4c99e0df5773.svg";
export { ForwardRef as ReactComponent };